const AbsColor = {
    Blue1: '#002a4e',
    Blue2: '#001E40',
    Blue3: '#335572',
    Blue4: '#5E8AB4',

    Red1: '#DA1F33',
    Red2: '#B51227',
    Red3: '#DF444E',

    Black1: '#000000',

    Yellow1: '#FFAD0A',
    Greeen1: '#4CA342',

    Gray1: '#f1f1f2',
    Gray2: '#524f4f',

    White1: '#FFFFFF',
    White2: '#F1F1F2 ',

    HighRisk: '#DA1F33',
    MediumRisk: '#FFAD00',
    LowRisk: '#5E8AB4'
};

export default AbsColor;
